import React from 'react';
import SettingsSideNav, { type SettingsSideNavItem } from './settings-side-nav';

interface SettingsSidebarLayoutProps {
  tabs: SettingsSideNavItem[];
  value: string;
  onValueChange: (value: string) => void;
  children: React.ReactNode;
  /** Tailwind min-height class for the grid, e.g. "min-h-[460px]" */
  minHeight?: string;
}

/**
 * SettingsSidebarLayout
 *
 * The sidebar + content-pane shell used across Settings screens (Fleet /
 * Compliance Defaults, IVR Settings, etc.): a fixed-width vertical nav on the
 * left (SettingsSideNav) and the active section's content on the right.
 * Usually placed directly inside a Card's CardContent (with className="p-0"
 * on the CardContent so this component's own padding isn't doubled up).
 */
const SettingsSidebarLayout: React.FC<SettingsSidebarLayoutProps> = ({
  tabs,
  value,
  onValueChange,
  children,
  minHeight = 'min-h-[400px]',
}) => (
  <div className={`grid grid-cols-1 lg:grid-cols-[260px_1fr] ${minHeight}`}>
    <aside className="border-b lg:border-b-0 lg:border-r border-yellow-900/20 bg-zinc-950 p-3">
      <SettingsSideNav tabs={tabs} value={value} onValueChange={onValueChange} />
    </aside>
    <section className="p-5 lg:p-6 bg-zinc-900/90">{children}</section>
  </div>
);

export default SettingsSidebarLayout;
